import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import uuid4 from 'uuid/v4';

import IconButton from 'components/IconButton';
import ToggleSwitch from 'components/ToggleSwitch';
import ToggleSwitchWithNumber from 'components/ToggleSwitchWithNumber';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import 'components/Filters/styles.css';
import './styles.css';

interface FilterSectionProps {
  label: string;
  data: Array<{label: string; data: Array<{label: string; key: string}>}>;
  value: Array<string>;
  classNameForTesting?: string;
  onFilterChange: (newValue: Array<string>) => void;
}

class TreeSelect extends React.Component<FilterSectionProps> {
  state = {
    sectionOpened: false,
    subsectionsOpened: []
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  toggleSubsection = subsectionLabel => {
    this.setState({
      subsectionsOpened: _.xor(this.state.subsectionsOpened, [subsectionLabel])
    });
  };

  onChange = (selectedKey: string) => {
    this.props.onFilterChange(_.xor(this.props.value, [selectedKey]));
  };

  onSectionChange = (sectionData: Array<string>) => {
    if (!_.isEmpty(_.intersection(this.props.value, sectionData))) {
      this.props.onFilterChange(_.difference(this.props.value, sectionData));
    } else {
      this.props.onFilterChange([...this.props.value, ...sectionData]);
    }
  };

  removeWhitespaces = str => str.replace(' ', '');

  render() {
    const {label, data} = this.props;

    return (
      <div
        className={classNames(
          'FilterSection',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div
          className={classNames(
            'FilterSection__header colab-centered-v colab-bold',
            `IconButton${this.removeWhitespaces(label)}Container`
          )}>
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>{label}</div>
        </div>
        <div className="FilterSection__content">
          {data.map(({label, data}) => {
            const sectionOpened = _.includes(
              this.state.subsectionsOpened,
              label
            );
            const dataKeys = data.map(({key}) => key);
            return (
              <React.Fragment key={uuid4()}>
                <div
                  className="TreeSelect__subsection colab-row-space-between colab-centered-v"
                  key={label}>
                  <div
                    className={classNames(
                      'colab-centered-v',
                      `IconButton${this.removeWhitespaces(label)}Container`
                    )}>
                    <IconButton
                      src={arrowRightIcon}
                      srcActive={arrowDownIcon}
                      alt="Toggle subsection"
                      onClick={() => this.toggleSubsection(label)}
                      active={sectionOpened}
                    />
                    <div className="colab-bold">{label}</div>
                  </div>
                  <ToggleSwitchWithNumber
                    number={_.intersection(this.props.value, dataKeys).length}
                    onChange={() => this.onSectionChange(dataKeys)}
                  />
                </div>
                {data.map(({label, key}) => (
                  <div
                    className={classNames(
                      'TreeSelect__row colab-row-space-between colab-clickable',
                      {'TreeSelect__row--hidden': !sectionOpened}
                    )}
                    onClick={() => this.onChange(key)}
                    key={key}>
                    <div>{label}</div>
                    <ToggleSwitch value={_.includes(this.props.value, key)} />
                  </div>
                ))}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TreeSelect;
